import { render, staticRenderFns } from "./ProfileContracts.vue?vue&type=template&id=56b90a8c&scoped=true"
import script from "./ProfileContracts.vue?vue&type=script&lang=js"
export * from "./ProfileContracts.vue?vue&type=script&lang=js"
import style0 from "./ProfileContracts.vue?vue&type=style&index=0&id=56b90a8c&prod&lang=scss&scoped=true"
import style1 from "./ProfileContracts.vue?vue&type=style&index=1&id=56b90a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b90a8c",
  null
  
)

export default component.exports